import { createContext, useContext } from 'react';

const LocationContext = createContext({
  heroTitle: '',
  heroSubtitle: '',
  heroDescription: '',
  heroBackgroundImage: '',
  heroMobileBackgroundImage: '',
  heroCtaButtonText: '',
  heroCtaButtonUrl: '',
  heroCtaButtonScrollToComponent: '',
  offices: [],
  marketoFormTitle: ''
});

LocationContext.displayName = 'LocationContext';

export const withLocationContext =
  (Component) =>
  ({
    heroTitle,
    heroSubtitle,
    heroDescription,
    heroBackgroundImage,
    heroMobileBackgroundImage,
    heroCtaButtonText,
    heroCtaButtonUrl,
    heroCtaButtonScrollToComponent,
    offices,
    marketoFormTitle,
    ...passThroughProps
  }) =>
    (
      <LocationContext.Provider
        value={{
          heroTitle,
          heroSubtitle,
          heroDescription,
          heroBackgroundImage,
          heroMobileBackgroundImage,
          heroCtaButtonText,
          heroCtaButtonUrl,
          heroCtaButtonScrollToComponent,
          offices,
          marketoFormTitle
        }}
      >
        <Component {...passThroughProps} />
      </LocationContext.Provider>
    );

export const useLocationContext = () => useContext(LocationContext);
